import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import Icon from 'components/Icon/Icon';
import styles from '../Qualification.module.scss';

const QualificationDetails = ({
  lastEntry,
  index,
  qualification,
  deleteQualification,
  isOwn,
  user,
}) => {
  const handleDeleteQualification = () => {
    deleteQualification(index);
  };
  const end = moment(qualification.ended_at).format('LL');

  let dates = <i>{end}</i>;
  let topLine = (
    <div>
      <i style={{ color: '#aaa' }}>{qualification.qualification}</i>
    </div>
  );
  let className = 'mb';

  if (qualification.started_at) {
    const start = moment(qualification.started_at).format('LL');
    dates = (
      <i>
        {start} - {end}
      </i>
    );
  }

  if (lastEntry) className = '';

  return (
    <div className={`${className} ${styles.oneQualification}`}>
      <div>
        {topLine}
        {dates}
        <div>{qualification.content}</div>
      </div>
      {user && isOwn && (
        <div>
          <Icon
            icon="&#xe611;"
            style={{ marginLeft: '5px' }}
            onClick={handleDeleteQualification}
          />
        </div>
      )}
    </div>
  );
};

QualificationDetails.propTypes = {
  lastEntry: PropTypes.bool,
  index: PropTypes.number,
  qualification: PropTypes.object,
  deleteQualification: PropTypes.func,
  isOwn: PropTypes.bool,
  user: PropTypes.object,
};

export default QualificationDetails;
